import { useCallback, useEffect, useRef, useState } from "react";

/** Carica un dato asincrono; `reload` lo rilegge. `data` è undefined durante il caricamento. */
export function useAsync<T>(fn: () => Promise<T>, deps: unknown[]) {
  const [data, setData] = useState<T>();
  const [error, setError] = useState<unknown>();
  const seq = useRef(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const load = useCallback(fn, deps);

  const reload = useCallback(async () => {
    const mine = ++seq.current;
    setError(undefined);
    try {
      const v = await load();
      if (mine === seq.current) setData(v);
    } catch (e) {
      if (mine === seq.current) setError(e);
    }
  }, [load]);

  useEffect(() => {
    setData(undefined);
    void reload();
  }, [reload]);

  return { data, error, reload, setData };
}
